module.exports = __webpack_public_path__ + "static/media/newsletter-banner-2023b.c460371c.jpg";